module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path class="st0" d="M28.9 31.8L.6 60.1c-.8.8-.8 2.1 0 2.8.4.5.9.7 1.4.7.5 0 1-.2 1.4-.6L32 34.4 60.5 63c.4.4.9.6 1.4.6s1-.2 1.4-.6c.8-.8.8-2.1 0-2.8L35.1 31.8 63.4 3.4c.8-.8.8-2.1 0-2.8-.8-.8-2.1-.8-2.8 0L32 29.2 3.4.6C2.6-.2 1.3-.2.6.6c-.8.8-.8 2.1 0 2.8l28.3 28.4z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/close.svg
// module id = 524
// module chunks = 1